import { API_URL } from "../../../config";
import { authFetch } from "../../../utils";

const CannonAction = ({ action, stationId, stationName, zeusAvailable }) => {
  const handleClick = async () => {
    const via = zeusAvailable ? '' : ' (vía SMS, Zeus no disponible)';
    const confirmed = window.confirm(`¿Estás seguro de que quieres enviar la orden de '${action.actionName}' a los cañones de ${stationName}${via}?`);
    if (!confirmed) return;

    const endpoint = zeusAvailable
      ? `${API_URL}cannons/${stationId}/action/${action.actionId}`
      : `${API_URL}cannons/${stationId}/action-sms/${action.actionId}`;

    try {
      const response = await authFetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Error en el envío de la orden');
      }

      const result = await response.json();
      console.log('Respuesta del backend:', result);
      alert('Orden enviada');
    } catch (error) {
      console.error(error);
      alert('Hubo un problema al enviar la orden');
    }
  };

  return (
    <div style={{ marginBottom: '8px' }}>
      <button onClick={handleClick}>{action.actionName}</button>
    </div>
  );
};

export default CannonAction;
